import { formatDate } from "../../components/DateUtil";

export default function MagicEOMDetailList({ data}) {

    return (
        <>
            <div id="orderPaymentList" className="table-responsive table-hover table-sales text-nowrap">
                <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">ABO</th>
                            <th scope="col">Name</th>
                            <th scope="col">Member Type</th>
                            <th scope="col">Order No</th>
                            <th scope="col">Order Date</th>
                            <th scope="col">Status</th>
                            <th scope="col" className="text-end">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((order, index) => {
                                let memberType = ''
                                if ('M' === order.member_type) memberType = 'Member'
                                else if ('A' === order.member_type) memberType = 'ABO'

                                return (
                                    <tr key={index}>
                                        <td>{order.abono}</td>
                                        <td>{order.aboname}</td>
                                        <td>{memberType}</td>
                                        <td>{order.orderno}</td>
                                        <td>{formatDate(new Date(order.orderdate))}</td>
                                        <td>{order.orderstatus}</td>
                                        <td className="text-end">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                                .format(order.amount).replace("USD", "").trim()}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

        </>
    )
}
